import React from "react";

const Header = () => {
    return(

        <nav>
            <div className="text-center flex flex-col items-center mt-24 mb-12 text-5xl text-yellow-500 font-bold" >
                <p>Warung Bang Wildan</p>
            </div>
        </nav>

    )
}

export default Header;